import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ReactiveFormsModule, NgClass]
})
export class SelectComponent  {

  @Input() form;
  @Input() ngClass;
  @Input() value;
  @Input() disabled;
  @Input() name = '';
  @Input() options;
  @Input() optionValue;
  @Input() optionText;
  @Input() defaultDescription;
  @Input() defaultValue = '';
  @Output() valueChanges = new EventEmitter();

  constructor() { }

}
